<template>
  <div class="video-review">
    <svg style="display: none" width="0" height="0">
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="video-icon">
        <path d="M22.4609 6.25C22.2266 6.25 21.9922 6.32812 21.7578 6.48438L17.5 9.17969V6.875C17.5 5.85938 16.5625 5 15.4688 5H3.24219C2.14844
          5 1.25 5.85938 1.25 6.875V18.1641C1.25 19.1797 2.14844 20 3.24219 20H15.4688C16.5625 20 17.5 19.1797 17.5 18.1641V15.8594L21.7578
          18.5547C21.9922 18.7109 22.2266 18.75 22.4609 18.75C23.125 18.75 23.75 18.2422 23.75 17.5391V7.5C23.75 6.75781 23.125 6.25 22.4609
          6.25ZM15.625 10.3125V18.0859C15.5859 18.125 15.5469 18.125 15.4688 18.125H3.24219C3.16406 18.125 3.125 18.125 3.125
          18.0859V6.95312C3.125 6.91406 3.16406 6.875 3.24219 6.875H15.4688C15.5469 6.875 15.5859 6.91406 15.625 6.95312V10.3125ZM21.875
          16.4062L17.5 13.6719V11.3672L21.875 8.63281V16.4062Z" />
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="upload-icon">
        <path d="M20 19.8438C20 19.6094 19.7656 19.375 19.5312 19.375H5.46875C5.19531 19.375 5 19.6094 5 19.8438V20.7812C5 21.0547 5.19531 21.25
          5.46875 21.25H19.5312C19.7656 21.25 20 21.0547 20 20.7812V19.8438ZM5.54688 9.96094C4.375 11.1328 5.19531 13.125 6.875
          13.125H8.86719V16.25C8.86719 17.3047 9.72656 18.125 10.7422 18.125H14.2188C15.2344 18.125 16.0938 17.3047 16.0938
          16.25V13.125H18.125C19.7656 13.125 20.625 11.1328 19.4141 9.96094L13.8281 4.33594C13.0859 3.59375 11.875 3.59375 11.1719
          4.33594L5.54688 9.96094ZM6.875 11.25L12.5 5.625L18.125 11.25H14.2188V16.25H10.7422V11.25H6.875Z" />
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="cross-icon">
        <path d="M13.7891 12.5L17.8125 8.51562L18.6328 7.69531C18.75 7.57812 18.75 7.38281 18.6328 7.22656L17.7734 6.36719C17.6172 6.25 17.4219
          6.25 17.3047 6.36719L12.5 11.2109L7.65625 6.36719C7.53906 6.25 7.34375 6.25 7.1875 6.36719L6.32812 7.22656C6.21094 7.38281 6.21094
          7.57812 6.32812 7.69531L11.1719 12.5L6.32812 17.3438C6.21094 17.4609 6.21094 17.6562 6.32812 17.8125L7.1875 18.6719C7.34375 18.7891
          7.53906 18.7891 7.65625 18.6719L12.5 13.8281L16.4844 17.8516L17.3047 18.6719C17.4219 18.7891 17.6172 18.7891 17.7734 18.6719L18.6328
          17.8125C18.75 17.6562 18.75 17.4609 18.6328 17.3438L13.7891 12.5Z" />
      </symbol>
    </svg>
    <span class="video-review-caption">{{ item.title }}</span>
    <div v-show="!hasVideo && !isStartRecording" class="video-review-box video-review-aspect-ratio">
      <button type="button" class="video-review-btn" @click="recordVideo" :disabled="!chosenMimeType">
        <svg width="24" height="24" viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <use href="#video-icon" />
        </svg>
        Record a video
      </button>
      <p>Or upload your video feedback</p>
      <label class="video-review-btn btn-borderless">
        <input accept=".mp4, .webm, .mov, .avi, .mkv"
          type="file"
          id="video-input"
          ref="video-input"
          @change="uploadFile">
        <svg width="24" height="24" viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <use href="#upload-icon" />
        </svg>
        Select file
      </label>
    </div>
    <small v-show="!hasVideo && !isStartRecording">
      You can record a video <b>40</b> seconds long. Or upload <b>.MP4 .MOV .AVI .MKV.</b> file and no more than <b>20Mb</b>.
    </small>
    <div v-show="!hasVideo && isStartRecording && counter" class="video-review-couter video-review-aspect-ratio">
      {{ counter }}
    </div>
    <div v-show="!hasVideo && isStartRecording && !counter && !stream" class="video-review-couter loading video-review-aspect-ratio">
      <i class="far fa-spinner-third fa-spin" />
    </div>
    <div v-show="!hasVideo && isStartRecording && !counter && stream" class="video-review-aspect-ratio">
      <video ref="recordingVideo" autoplay playsinline muted />
    </div>
    <div v-show="hasVideo && !isStartRecording">
      <video controls ref="preparedVideo" playsinline />
    </div>
    <div v-show="hasVideo && !isStartRecording" class="video-review-controls">
      <button type="button" class="video-review-btn btn-borderless btn-md" @click="recordVideo" :disabled="!chosenMimeType">
        <svg width="24" height="24" viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <use href="#video-icon" />
        </svg>
        Record new video
      </button>

      <label for="video-input" class="video-review-btn btn-borderless btn-md">
        <svg width="24" height="24" viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <use href="#upload-icon" />
        </svg>
        Select file
      </label>
      <button type="button" class="video-review-btn btn-borderless btn-md btn-red" @click="clearVideoInput">
        <svg width="24" height="24" viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <use href="#cross-icon" />
        </svg>
        Delete
      </button>
    </div>

    <div v-show="!hasVideo && isStartRecording && !counter && stream" class="video-review-controls">
      <button type="button" class="video-review-btn btn-borderless btn-md" @click="stopRecordingVideo">
        <svg width="24" height="24" viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <use href="#video-icon" />
        </svg>
        Stop recording
      </button>
    </div>

    <div v-if="errorText" class="video-review-errors">
      {{ errorText }}
    </div>
  </div>
</template>

<script>
const ALLOWED_FILE_SIZE = 20 // MB
const DURATION = 40000

export default {
  props: {
    item: { type: Object, required: true },
    errors: { type: Array, default: () => []}
  },
  data() {
    return {
      localError: '',
      player: null,
      isStartRecording: false,
      hasVideo: false,

      chosenMimeType: null,
      mediaRecorder: null,
      counter: 0,
      stream: null
    }
  },
  mounted() {
    const mimeTypes = [
      'video/mp4',
      'video/webm'
    ]
    this.chosenMimeType = mimeTypes.find((type) => MediaRecorder?.isTypeSupported(type))
    if (!this.chosenMimeType) this.localError = 'Video recording is not supported in your web browser'
  },
  computed: {
    errorText() {
      return this.localError || [...this.errors].join(', ')
    }
  },
  methods: {
    uploadFile(e) {
      const [file] = e.target.files

      if (ALLOWED_FILE_SIZE < (file.size / 1024 / 1024)) {
        this.localError = `Upload file is larger than ${ALLOWED_FILE_SIZE}MB`
        this.hasVideo = false
        e.target.value = null
        return
      }

      this.resetVideo()
      this.hasVideo = true

      const newObjectUrl = URL.createObjectURL(file)
      this.$refs.preparedVideo.src = newObjectUrl

      this.$emit('input', file)
    },
    async recordVideo() {
      this.resetVideo()
      this.hasVideo = false
      this.isStartRecording = true
      this.$emit('on-lock', true)

      try {
        this.stream = await navigator.mediaDevices.getUserMedia({
          video: {
            width: { min: 640, ideal: 640, max: 1280 },
            height: { min: 360, ideal: 360, max: 720 }
          },
          audio: true
        })
      } catch {
        this.stream = null
        this.counter = 0
        this.isStartRecording = false
        this.localError = 'Permission denied'
        return
      }

      this.counter = 3
      this.counterId = setInterval(() => {
        this.counter--
        if (this.counter === 0) {
          clearInterval(this.counterId)
          this.$refs.recordingVideo.srcObject = this.stream

          this.mediaRecorder = new MediaRecorder(this.stream, {
            mimeType: this.chosenMimeType
          })

          this.mediaRecorder.addEventListener('dataavailable', (event) => {
            this.$emit('input', event.data)
            this.$emit('on-lock', false)
            this.$refs.preparedVideo.src = URL.createObjectURL(event.data)
          })

          this.mediaRecorder.start()

          this.timerId = setTimeout(() => {
            this.stopRecordingVideo()
          }, DURATION)
        }
      }, 1000)
    },
    stopRecordingVideo() {
      clearTimeout(this.timerId)
      this.hasVideo = true
      this.isStartRecording = false
      this.mediaRecorder.stop()
      this.stream.getTracks().forEach((track) => track.stop())
      this.stream = null
    },
    resetVideo() {
      this.localError = ''
      const videoEls = document.querySelector('.video-review').querySelectorAll('video')
      videoEls.forEach((el) => {
        el.pause()
        el.removeAttribute('src')
        el.load()
      })
      this.$refs['video-input'].value = null
    },
    clearVideoInput() {
      this.resetVideo()
      this.isStartRecording = false
      this.hasVideo = false
      this.$emit('input', null)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~stylesheets/feedback_page/video-review';
</style>
